import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import { useLocation, useNavigate } from "react-router-dom";
import ToastError from "../../../../../../NotificationToast/ToastError";
import { PulseLoader } from "react-spinners";
import swal from "sweetalert";

const css = `
  @keyframes logShimmer {
    0% {
      background-position: -700px 0;
    }

    100% {
      background-position: 700px 0;
    }
  }

  .log-page {
    width: 100%;
    padding: 4px 0 24px;
  }

  .log-filter-card,
  .log-table-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e8edf5;
    border-radius: 16px;
    box-shadow: 0 5px 18px rgba(47, 72, 124, 0.06);
  }

  .log-filter-card {
    padding: 18px;
    margin-bottom: 16px;
  }

  .log-filter-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 15px;
  }

  .log-filter-title {
    margin: 0;
    color: #233876;
    font-size: 15px;
    font-weight: 700;
  }

  .log-filter-caption {
    margin: 3px 0 0;
    color: #7a869f;
    font-size: 12px;
  }

  .log-filter-grid {
    display: grid;
    grid-template-columns:
      minmax(140px, 0.9fr)
      minmax(180px, 1.1fr)
      minmax(120px, 0.9fr)
      auto;
    align-items: end;
    gap: 12px;
  }

  .log-field {
    min-width: 0;
  }

  .log-label {
    display: block;
    margin-bottom: 7px;
    color: #475569;
    font-size: 12px;
    font-weight: 600;
  }

  .log-select,
  .log-search-input,
  .log-page-size {
    width: 100%;
    border: 1px solid #dbe3f0;
    background: #ffffff;
    color: #27364f;
    outline: none;
    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;
  }

  .log-select {
    height: 42px;
    padding: 0 38px 0 12px;
    border-radius: 10px;
    font-size: 13px;
    cursor: pointer;
  }

  .log-select:hover,
  .log-search-input:hover,
  .log-page-size:hover {
    border-color: #bdc9dc;
  }

  .log-select:focus,
  .log-search-input:focus,
  .log-page-size:focus {
    border-color: #4267c7;
    box-shadow: 0 0 0 3px rgba(66, 103, 199, 0.12);
  }

  .log-select:disabled {
    background: #f5f7fb;
    color: #9aa5b8;
    cursor: not-allowed;
  }

  .log-search-button {
    min-width: 104px;
    height: 42px;
    padding: 0 18px;
    border: 0;
    border-radius: 10px;
    background: #f0ad1f;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 5px 12px rgba(240, 173, 31, 0.2);
    transition:
      transform 0.18s ease,
      box-shadow 0.18s ease,
      background 0.18s ease;
  }

  .log-search-button:hover:not(:disabled) {
    background: #dfa017;
    transform: translateY(-1px);
    box-shadow: 0 7px 16px rgba(240, 173, 31, 0.28);
  }

  .log-search-button:disabled {
    background: #cfd5df;
    color: #f8fafc;
    box-shadow: none;
    cursor: not-allowed;
  }

  .log-shimmer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(
      90deg,
      #e4edfc 8%,
      #f7faff 18%,
      #e4edfc 33%
    );
    background-size: 900px 100%;
    animation: logShimmer 1.25s linear infinite;
  }

  .log-shimmer-label {
    width: 70px;
    height: 10px;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .log-shimmer-control {
    width: 100%;
    height: 42px;
    border-radius: 10px;
  }

  .log-shimmer-button {
    width: 104px;
    height: 42px;
    border-radius: 10px;
  }

  .log-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    margin: -4px 0 10px;
  }

  .log-table-card {
    overflow: hidden;
  }

  .log-table-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 16px 18px;
    border-bottom: 1px solid #edf1f6;
  }

  .log-search-wrap {
    position: relative;
    width: min(100%, 360px);
  }

  .log-search-icon {
    position: absolute;
    top: 50%;
    left: 13px;
    transform: translateY(-50%);
    color: #8c98aa;
    font-size: 16px;
    pointer-events: none;
  }

  .log-search-input {
    height: 40px;
    padding: 0 13px 0 39px;
    border-radius: 10px;
    font-size: 13px;
  }

  .log-result-info {
    flex-shrink: 0;
    color: #7a8699;
    font-size: 12px;
  }

  .log-table-wrap {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .log-table {
    width: 100%;
    min-width: 850px;
    margin: 0;
    border-collapse: separate;
    border-spacing: 0;
  }

  .log-table thead th {
    padding: 13px 15px;
    background: #f4f7ff;
    color: #3453a4;
    border: 0;
    border-bottom: 1px solid #e3eaf6;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
    text-align: left;
    white-space: nowrap;
  }

  .log-table thead th:first-child,
  .log-table tbody td:first-child {
    width: 72px;
    text-align: center;
  }

  .log-table tbody td {
    padding: 13px 15px;
    color: #334155;
    border: 0;
    border-bottom: 1px solid #edf1f6;
    font-size: 13px;
    line-height: 1.55;
    vertical-align: middle;
  }

  .log-table tbody tr:last-child td {
    border-bottom: 0;
  }

  .log-table tbody tr:hover td {
    background: #fbfcff;
  }

  .log-number-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 31px;
    height: 31px;
    border: 1px solid #dce5f5;
    border-radius: 50%;
    background: #f5f8ff;
    color: #3558b0;
    font-size: 12px;
    font-weight: 700;
  }

  .log-student-name {
    color: #24324b;
    font-weight: 600;
  }

  .log-date,
  .log-time {
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    padding: 4px 9px;
    border-radius: 8px;
    background: #f6f8fc;
    color: #4f5f78;
    font-size: 12px;
    white-space: nowrap;
  }

  .log-empty {
    padding: 42px 20px !important;
    color: #8a95a8 !important;
    text-align: center !important;
  }

  .log-empty-title {
    display: block;
    margin-bottom: 4px;
    color: #536078;
    font-size: 13px;
    font-weight: 700;
  }

  .log-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 18px;
    border-top: 1px solid #edf1f6;
    background: #ffffff;
  }

  .log-pagination-left,
  .log-pagination-right,
  .log-page-numbers {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .log-page-info {
    color: #768197;
    font-size: 12px;
    white-space: nowrap;
  }

  .log-page-size {
    width: auto;
    height: 34px;
    padding: 0 30px 0 10px;
    border-radius: 8px;
    font-size: 12px;
    cursor: pointer;
  }

  .log-page-button,
  .log-page-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dbe3ef;
    background: #ffffff;
    color: #5e6b80;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.18s ease;
  }

  .log-page-button {
    min-width: 58px;
    height: 34px;
    padding: 0 11px;
    border-radius: 8px;
  }

  .log-page-number {
    width: 34px;
    height: 34px;
    padding: 0;
    border-radius: 50%;
  }

  .log-page-button:hover:not(:disabled),
  .log-page-number:hover:not(.active) {
    border-color: #9fb1d8;
    background: #f4f7ff;
    color: #3558b0;
  }

  .log-page-number.active {
    border-color: #4165c3;
    background: #4165c3;
    color: #ffffff;
    box-shadow: 0 4px 10px rgba(65, 101, 195, 0.22);
  }

  .log-page-button:disabled {
    background: #f5f7fa;
    color: #b2bac7;
    cursor: not-allowed;
  }

  .log-page-dots {
    min-width: 18px;
    color: #8792a5;
    text-align: center;
    font-size: 12px;
  }

  @media (max-width: 1050px) {
    .log-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .log-search-button {
      width: 100%;
    }
  }

  @media (max-width: 780px) {
    .log-page {
      padding-top: 0;
    }

    .log-filter-card {
      padding: 15px;
      border-radius: 14px;
    }

    .log-filter-grid {
      grid-template-columns: 1fr;
      gap: 11px;
    }

    .log-filter-head {
      align-items: flex-start;
      margin-bottom: 14px;
    }

    .log-search-button,
    .log-shimmer-button {
      width: 100%;
    }

    .log-table-card {
      border-radius: 14px;
    }

    .log-table-toolbar {
      align-items: stretch;
      flex-direction: column;
      padding: 14px;
    }

    .log-search-wrap {
      width: 100%;
    }

    .log-result-info {
      padding-left: 2px;
    }

    .log-pagination {
      align-items: stretch;
      flex-direction: column;
      padding: 13px 14px;
    }

    .log-pagination-left,
    .log-pagination-right {
      width: 100%;
      justify-content: space-between;
    }

    .log-page-numbers {
      max-width: 100%;
      overflow-x: auto;
      padding: 2px 0;
    }
  }

  @media (max-width: 480px) {
    .log-pagination-left {
      align-items: flex-start;
      flex-direction: column;
    }

    .log-pagination-right {
      gap: 6px;
    }

    .log-page-button {
      min-width: 52px;
      padding: 0 9px;
    }

    .log-page-number {
      width: 32px;
      height: 32px;
    }
  }
`;

export default function LogAbsensi() {
  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level");

  const location = useLocation();
  const navigate = useNavigate();

  const firstLoadDone = useRef(false);

  const [loadingMaster, setLoadingMaster] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getData, setGetData] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [hasSearched, setHasSearched] = useState(false);

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  useEffect(() => {
    document.title = "Log Absensi";
  }, []);

  useEffect(() => {
    const level = localStorage.getItem("level");

    let storageItems = [];

    try {
      storageItems =
        JSON.parse(localStorage.getItem("role_permission")) || [];
    } catch (error) {
      storageItems = [];
    }

    if (level === "developer" || level === "superadmin") {
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
    }
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const sortSchools = useCallback((schools) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const schoolA = (a?.school_name || "").toUpperCase();
      const schoolB = (b?.school_name || "").toUpperCase();

      const indexA = order.findIndex((level) =>
        schoolA.includes(level)
      );

      const indexB = order.findIndex((level) =>
        schoolB.includes(level)
      );

      const safeIndexA =
        indexA === -1 ? order.length : indexA;

      const safeIndexB =
        indexB === -1 ? order.length : indexB;

      if (safeIndexA !== safeIndexB) {
        return safeIndexA - safeIndexB;
      }

      return schoolA.localeCompare(schoolB, "id", {
        numeric: true,
      });
    });
  }, []);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      if (!branchId) {
        setGetDataSchool([]);

        setForm2((prev) => ({
          ...prev,
          ysb_school_id: "",
        }));

        return;
      }

      setLoadingSchool(true);
      setGetDataSchool([]);

      setForm2((prev) => ({
        ...prev,
        ysb_school_id: "",
      }));

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=1&limit=1000&ascending=1&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let schools = response?.data?.data || [];

          if (
            storageLevel === "developer" ||
            storageLevel === "superadmin"
          ) {
            schools = schools.filter(
              (school) =>
                school?.ysb_branch_id === branchId
            );
          }

          if (branchId === "BKS") {
            schools = schools.filter(
              (school) =>
                school?.school_code !==
                "BASEMENT_BEKASI"
            );
          }

          const sortedSchools = sortSchools(schools);

          setGetDataSchool(sortedSchools);

          setForm2((prev) => ({
            ...prev,
            ysb_school_id:
              sortedSchools[0]?.school_code || "",
          }));
        }
      } catch (error) {
        setGetDataSchool([]);

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data sekolah",
        });
      } finally {
        setLoadingSchool(false);
      }
    },
    [fetchParams, sortSchools, storageLevel]
  );

  useEffect(() => {
    let active = true;

    const fetchMasterData = async () => {
      setLoadingMaster(true);

      try {
        const [
          branchResponse,
          semesterResponse,
        ] = await Promise.all([
          APIMS.get(
            "/api/access/branches?page=1&limit=1000&ascending=1&search=",
            fetchParams
          ),
          APIMS.get(
            "/api/access/semesters?page=1&limit=1000&ascending=1&search=",
            fetchParams
          ),
        ]);

        if (!active) {
          return;
        }

        const branches =
          branchResponse?.data?.data || [];

        const semesters =
          semesterResponse?.data?.data || [];

        const activeSemester =
          semesters.find(
            (semester) =>
              Number(semester?.status) === 1
          ) || semesters[0];

        setGetDataBranch(branches);
        setGetDataSemesterMap(semesters);

        setForm2((prev) => ({
          ...prev,
          ysb_branch_id:
            branches[0]?.branch_code || "",
          ysb_semester_id:
            activeSemester?.id || "",
        }));
      } catch (error) {
        if (!active) {
          return;
        }

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data filter",
        });
      } finally {
        if (active) {
          setLoadingMaster(false);
        }
      }
    };

    fetchMasterData();

    return () => {
      active = false;
    };
  }, [fetchParams]);

  useEffect(() => {
    if (form2.ysb_branch_id) {
      fetchSchoolsByBranch(
        form2.ysb_branch_id
      );
    }
  }, [
    form2.ysb_branch_id,
    fetchSchoolsByBranch,
  ]);

  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id
    ) {
      return;
    }

    setIsFetching(true);
    setSearchKeyword("");

    try {
      const response = await APISD.get(
        "/api/absen-logs",
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
          params: {
            page: 1,
            limit: 1000,
            ascending: 0,
            search: "",
            ysb_semester_id:
              form2.ysb_semester_id,
            ysb_branch_id:
              form2.ysb_branch_id,
            ysb_school_id:
              form2.ysb_school_id,
          },
        }
      );

      if (response?.status === 200) {
        setGetData(
          response?.data?.data || []
        );

        setTablePage(1);
      }
    } catch (error) {
      setGetData([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data log absensi",
      });
    } finally {
      setIsFetching(false);
    }
  }, [form2, token]);

  const filterComplete = Boolean(
    form2.ysb_semester_id &&
      form2.ysb_branch_id &&
      form2.ysb_school_id
  );

  const canSearch =
    filterComplete &&
    !loadingMaster &&
    !loadingSchool &&
    !isFetching;

  useEffect(() => {
    if (
      firstLoadDone.current ||
      loadingMaster ||
      loadingSchool ||
      !filterComplete
    ) {
      return;
    }

    firstLoadDone.current = true;

    const loadFirstData = async () => {
      await GetResponseData();
      setHasSearched(true);
    };

    loadFirstData();
  }, [
    GetResponseData,
    filterComplete,
    loadingMaster,
    loadingSchool,
  ]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm2((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (firstLoadDone.current) {
      setHasSearched(false);
    }
  };

  const handleCari = async () => {
    if (loadingSchool) {
      swal({
        title: "Mohon tunggu",
        text: "Data sekolah masih dimuat. Coba lagi sebentar.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });

      return;
    }

    if (!filterComplete) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan semester, cabang, dan sekolah sudah dipilih.",
        icon: "warning",
      });

      return;
    }

    setHasSearched(false);
    setGetData([]);

    await GetResponseData();

    setHasSearched(true);
  };

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const query = searchKeyword
      .trim()
      .toLowerCase();

    const result = !query
      ? getData
      : getData.filter((item) => {
          const searchableValues = [
            item?.name_student,
            item?.att_date,
            item?.att_time,
            item?.name_school,
            item?.name_branch,
          ];

          return searchableValues.some((value) =>
            String(value ?? "")
              .toLowerCase()
              .includes(query)
          );
        });

    return [...result].sort((a, b) =>
      nameCollator.compare(
        String(a?.name_student ?? "").trim(),
        String(b?.name_student ?? "").trim()
      )
    );
  }, [
    getData,
    nameCollator,
    searchKeyword,
  ]);

  const totalRows = filteredData.length;

  const totalPages = useMemo(
    () =>
      Math.max(
        1,
        Math.ceil(
          totalRows /
            Math.max(1, rowsPerPage)
        )
      ),
    [rowsPerPage, totalRows]
  );

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const startIndex =
      (tablePage - 1) * rowsPerPage;

    return filteredData.slice(
      startIndex,
      startIndex + rowsPerPage
    );
  }, [
    filteredData,
    rowsPerPage,
    tablePage,
  ]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;

    if (totalPages <= maxButtons) {
      return Array.from(
        { length: totalPages },
        (_, index) => index + 1
      );
    }

    const pages = [1];

    const start = Math.max(
      2,
      tablePage - 1
    );

    const end = Math.min(
      totalPages - 1,
      tablePage + 1
    );

    if (start > 2) {
      pages.push("left-dots");
    }

    for (
      let page = start;
      page <= end;
      page += 1
    ) {
      pages.push(page);
    }

    if (end < totalPages - 1) {
      pages.push("right-dots");
    }

    pages.push(totalPages);

    return pages;
  }, [tablePage, totalPages]);

  const goToPage = (page) => {
    const nextPage = Math.min(
      Math.max(1, Number(page) || 1),
      totalPages
    );

    setTablePage(nextPage);
  };

  const startRow =
    totalRows === 0
      ? 0
      : (tablePage - 1) *
          rowsPerPage +
        1;

  const endRow = Math.min(
    tablePage * rowsPerPage,
    totalRows
  );

  const getSemesterLabel = (semester) =>
    `${semester?.name_year || "-"} (Semester ${
      semester?.semester || "-"
    })`;

  return (
    <div className="log-page mt-4">
      <style>{css}</style>

      <section className="log-filter-card">
        <div className="log-filter-head">
          <div>
            <h2 className="log-filter-title">
              Filter Log Absensi
            </h2>

            <p className="log-filter-caption">
              Pilih semester, cabang, dan sekolah
              untuk menampilkan data.
            </p>
          </div>
        </div>

        {loadingMaster ? (
          <div
            className="log-filter-grid"
            aria-label="Memuat filter"
          >
            {[1, 2, 3].map((item) => (
              <div
                className="log-field"
                key={item}
              >
                <div className="log-shimmer log-shimmer-label" />

                <div className="log-shimmer log-shimmer-control" />
              </div>
            ))}

            <div className="log-shimmer log-shimmer-button" />
          </div>
        ) : (
          <div className="log-filter-grid">
            <div className="log-field">
              <label
                className="log-label"
                htmlFor="ysb_semester_id"
              >
                Semester
              </label>

              <select
                id="ysb_semester_id"
                className="log-select"
                name="ysb_semester_id"
                value={
                  form2.ysb_semester_id
                }
                onChange={handleChange}
              >
                <option
                  value=""
                  disabled
                >
                  Pilih Semester
                </option>

                {getDataSemesterMap.map(
                  (semester) => (
                    <option
                      key={semester?.id}
                      value={semester?.id}
                    >
                      {getSemesterLabel(
                        semester
                      )}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="log-field">
              <label
                className="log-label"
                htmlFor="ysb_branch_id"
              >
                Cabang
              </label>

              <select
                id="ysb_branch_id"
                className="log-select"
                name="ysb_branch_id"
                value={
                  form2.ysb_branch_id
                }
                onChange={handleChange}
              >
                <option
                  value=""
                  disabled
                >
                  Pilih Cabang
                </option>

                {getDataBranch.map(
                  (branch) => (
                    <option
                      key={
                        branch?.branch_code
                      }
                      value={
                        branch?.branch_code
                      }
                    >
                      {branch?.branch_name}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="log-field">
              <label
                className="log-label"
                htmlFor="ysb_school_id"
              >
                Sekolah
              </label>

              <select
                id="ysb_school_id"
                className="log-select"
                name="ysb_school_id"
                value={
                  form2.ysb_school_id
                }
                onChange={handleChange}
                disabled={
                  loadingSchool ||
                  !form2.ysb_branch_id
                }
              >
                <option
                  value=""
                  disabled
                >
                  {loadingSchool
                    ? "Memuat data sekolah..."
                    : "Pilih Sekolah"}
                </option>

                {getDataSchool.map(
                  (school) => (
                    <option
                      key={
                        school?.school_code
                      }
                      value={
                        school?.school_code
                      }
                    >
                      {school?.school_name}
                    </option>
                  )
                )}
              </select>
            </div>

            <button
              type="button"
              className="log-search-button"
              onClick={handleCari}
              disabled={!canSearch}
            >
              {isFetching
                ? "Memuat..."
                : "Tampilkan Data"}
            </button>
          </div>
        )}
      </section>

      {isFetching && (
        <div className="log-loading">
          <PulseLoader
            color="#3f5bea"
            size={10}
          />
        </div>
      )}

      {hasSearched && !isFetching && (
        <section className="log-table-card">
          <div className="log-table-toolbar">
            <div className="log-search-wrap">
              <span
                className="log-search-icon"
                aria-hidden="true"
              >
                ⌕
              </span>

              <input
                type="text"
                className="log-search-input"
                placeholder="Cari nama siswa, tanggal, sekolah, atau cabang"
                value={searchKeyword}
                onChange={(event) =>
                  setSearchKeyword(
                    event.target.value
                  )
                }
              />
            </div>

            <div className="log-result-info">
              Total{" "}
              <strong>{totalRows}</strong>{" "}
              data
            </div>
          </div>

          <div className="log-table-wrap">
            <table className="log-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nama Siswa</th>
                  <th>Tanggal</th>
                  <th>Jam</th>
                  <th>Sekolah</th>
                  <th>Cabang</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length >
                0 ? (
                  paginatedData.map(
                    (row, index) => (
                      <tr
                        key={
                          row?.id ||
                          `${row?.name_student}-${index}`
                        }
                      >
                        <td>
                          <span className="log-number-badge">
                            {(tablePage -
                              1) *
                              rowsPerPage +
                              index +
                              1}
                          </span>
                        </td>

                        <td>
                          <span className="log-student-name">
                            {row?.name_student ||
                              "-"}
                          </span>
                        </td>

                        <td>
                          <span className="log-date">
                            {row?.att_date ||
                              "-"}
                          </span>
                        </td>

                        <td>
                          <span className="log-time">
                            {row?.att_time ||
                              "-"}
                          </span>
                        </td>

                        <td>
                          {row?.name_school ||
                            "-"}
                        </td>

                        <td>
                          {row?.name_branch ||
                            "-"}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="log-empty"
                    >
                      <span className="log-empty-title">
                        Data tidak ditemukan
                      </span>

                      Coba gunakan kata
                      pencarian lain atau ubah
                      filter.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalRows > 0 && (
            <div className="log-pagination">
              <div className="log-pagination-left">
                <span className="log-page-info">
                  Menampilkan{" "}
                  <strong>{startRow}</strong>
                  -
                  <strong>{endRow}</strong>{" "}
                  dari{" "}
                  <strong>
                    {totalRows}
                  </strong>{" "}
                  data
                </span>

                <select
                  className="log-page-size"
                  value={rowsPerPage}
                  onChange={(event) => {
                    setRowsPerPage(
                      Number(
                        event.target.value
                      ) || 10
                    );

                    setTablePage(1);
                  }}
                >
                  <option value={10}>
                    10 / halaman
                  </option>

                  <option value={25}>
                    25 / halaman
                  </option>

                  <option value={50}>
                    50 / halaman
                  </option>

                  <option value={100}>
                    100 / halaman
                  </option>
                </select>
              </div>

              <div className="log-pagination-right">
                <button
                  type="button"
                  className="log-page-button"
                  onClick={() =>
                    goToPage(
                      tablePage - 1
                    )
                  }
                  disabled={tablePage <= 1}
                >
                  Prev
                </button>

                <div className="log-page-numbers">
                  {pageNumbers.map(
                    (page) =>
                      typeof page ===
                      "string" ? (
                        <span
                          className="log-page-dots"
                          key={page}
                        >
                          ...
                        </span>
                      ) : (
                        <button
                          type="button"
                          key={page}
                          className={`log-page-number ${
                            page === tablePage
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            goToPage(page)
                          }
                        >
                          {page}
                        </button>
                      )
                  )}
                </div>

                <button
                  type="button"
                  className="log-page-button"
                  onClick={() =>
                    goToPage(
                      tablePage + 1
                    )
                  }
                  disabled={
                    tablePage >= totalPages
                  }
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </section>
      )}
    </div>
  );
}